import { render, staticRenderFns } from "./InputUploadFile.vue?vue&type=template&id=9270afe6&scoped=true"
import script from "./InputUploadFile.vue?vue&type=script&lang=js"
export * from "./InputUploadFile.vue?vue&type=script&lang=js"
import style0 from "./InputUploadFile.vue?vue&type=style&index=0&id=9270afe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9270afe6",
  null
  
)

export default component.exports